//* #region ----------------------------------------------- Types
export function createClone(el, deep) {
    return el.cloneNode(deep);
}
/* Custom WebComponent
-----------------------------------------------*/
export function defineComponent(tagName, componentClass, options) {
    customElements.define(tagName, componentClass, options);
}
